module.exports = __webpack_public_path__ + "static/media/intro-zoom.b1e1b061.jpg";